<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="40%"
            height="100%"
            no-click-animation
            >
            <v-card class="pa-3">
                <CardTitle :title="page_title" />
                <v-data-table
                    :headers="headers"
                    :items="desserts"
                    hide-default-footer
                    class="elevation-1"
                    >
                    <template v-slot:top>
                        <v-toolbar flat color="white" class="mt-1">
                            <div class="flex-grow-1">{{ propsTimeGolfName }}</div>
                            <div class="flex-grow-1">{{ propsTimePlanName }}</div>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.btn`]="{ item }">
                        <v-btn
                            :disabled="btn[1].isActive"
                            @click="displayRemoveOverLay(item)">削除</v-btn>
                    </template>
                </v-data-table>
                <v-pagination
                    class="my-2"
                    v-model="page"
                    :length="pageCount"
                    :total-visible="7"
                    @input="clickPagination"
                />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-4"
                        text
                        @click="closeModal">閉じる</v-btn>
                    <v-btn
                        :disabled="btn[2].isActive"
                        color="green darken-4"
                        text
                        @click="openChild">追加</v-btn>
                </v-card-actions>
                <RemoveOverLay
                    page-name="枠連携"
                    @processing="deletePlanTime"
                    @cancel="closeRemoveOverLay"
                    :process-result="process"
                    :overlay-switch="removeOverlay"
                />
            </v-card>
        </v-dialog>
        <PlanTime
            :propsPlanId="propsTimePlanId"
            :propsPlanName="propsTimePlanName"
            :propsCourse="coursesList"
            :dialog="timeDialog"
            :displayGolfCourse="timeGolfCourse"
            :displayGolfCourseName="propsTimeGolfName"
            @close="closeChild"
        />
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
// モーダル
import PlanTime from './PlanTime';
import RemoveOverLay from '@/components/overlay/RemoveOverlay';
// graghql
import {
    GET_PLAN_TIME_LIST,
    DELETE_PLAN_TIME } from '@/constants/plan';

export default {
    components: {
        CardTitle,
        PlanTime,
        RemoveOverLay
    },
    props: [
        'dialog',
        'propsTimeAdmin',
        'timeGolfCourse',
        'propsTimeGolfName',
        'propsTimePlanId',
        'propsTimePlanName'
    ],
    data () {
        return {
            // 削除確認用ポップアップ表示に関する制御値
            removeOverlay: false,
            // 登録画面の表示値
            timeDialog: false,
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: 'コース', value: 'course_name', align: 'center' },
                { text: '時間', value: 'playTime', align: 'center', sortable: false },
                { text: '', align: 'center', value: 'btn', sortable: false, width: '150' }
            ],
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '枠連携時間設定',
            // コースセレクト
            coursesList: [],
            // 削除用
            delete: {
                playStart: '',
                playEnd: '',
                courseCode: ''
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '削除', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true }
            ],
            vue_id: 'SCR0032',
            page: 1,
            pageCount: 0,
            // offset
            beginRow: 0,
            // 一覧の最大表示値
            limitRows: 10,
            // 連携時間データのカウント
            count: 0
        };
    },
    watch: {
        // 親からデータが渡ってきたときに発火
        async propsTimePlanId () {
            if (this.propsTimePlanId !== '') {
                this.getPlanTimeList();
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * プランに紐づく特典を取得
         * 発火タイミングはwatchで処理
         * ---------------------------------------------- */
        getPlanTimeList () {
            this.$apollo.mutate({
                mutation: GET_PLAN_TIME_LIST,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.timeGolfCourse,
                    plan_id: this.propsTimePlanId,
                    limit: this.limitRows,
                    offset: this.beginRow,
                    user_id: this.propsTimeAdmin.user_id,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            }).then(res => {
                const data = res.data.getPlanTimeList.PlanTimeList;
                this.count = res.data.getPlanTimeList.count;
                this.pageCount = Math.ceil(this.count / this.limitRows);
                this.desserts.splice(0, this.desserts.length);
                const list = data.map(res => {
                    const playTime = this.HourAndMinutes(res.play_start) +
                                     '～' +
                                     this.HourAndMinutes(res.play_end);
                    return {
                        'course_code': res.course_code,
                        'course_name': res.course_name,
                        'playTime': playTime,
                        'play_start': res.play_start,
                        'play_end': res.play_end
                    };
                });
                this.desserts = list;
                this.coursesList = res.data.getPlanTimeList.CoursesList;
                let opeList = res.data.getPlanTimeList.OperationAccessList;
                for (let list of opeList) {
                    this.btn.forEach(el => {
                        if (list.element_id === el.element_id) {
                            if (list.element_control === 0) {
                                el.isActive = true;
                            } else {
                                el.isActive = false;
                            }
                        }
                    });
                };
            });
        },
        /** ----------------------------------------------
         * 秒数を削る処理
         * @param time String
         * @return String "00:00"
         * ---------------------------------------------- */
        HourAndMinutes (time) {
            const timeArr = time.split(/:/);
            return timeArr[0] + ':' + timeArr[1];
        },
        /** ----------------------------------------------
         * 削除処理
         * ---------------------------------------------- */
        deletePlanTime () {
            this.$apollo.mutate({
                mutation: DELETE_PLAN_TIME,
                variables: {
                    plan_id: this.propsTimePlanId,
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.timeGolfCourse,
                    course_code: this.delete.courseCode,
                    play_start: this.delete.playStart,
                    play_end: this.delete.playEnd
                }
            }).then(res => {
                const data = res.data.deletePlanTime.result;
                if (data === 1) {
                    this.getPlanTimeList();
                    this.closeRemoveOverLay();
                } else {
                    throw new Error('エラーが発生しました。');
                }
            }).catch(error => {
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * 削除ダイアログを表示する
         * ---------------------------------------------- */
        displayRemoveOverLay (item) {
            this.delete.playStart = item.play_start;
            this.delete.playEnd = item.play_end;
            this.delete.courseCode = item.course_code;
            this.removeOverlay = true;
        },
        /** ----------------------------------------------
         * 削除ダイアログを閉じる
         * ---------------------------------------------- */
        closeRemoveOverLay (item) {
            this.process.result = '';
            this.removeOverlay = false;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        closeModal () {
            this.desserts.splice(0, this.desserts.length);
            this.$emit('close', ['times_count', this.count]);
        },
        /** ----------------------------------------------
         * 子コンポーネントを表示する
         * ---------------------------------------------- */
        openChild () {
            this.timeDialog = true;
        },
        /** ----------------------------------------------
         * 子コンポーネントを閉じる
         * ---------------------------------------------- */
        closeChild () {
            this.timeDialog = false;
            this.getPlanTimeList();
        },
        /** --------------------------------------------
        * ページネーション処理
        * -------------------------------------------- */
        clickPagination () {
            this.beginRow = this.page * this.limitRows - this.limitRows;
            this.getPlanTimeList();
        }
    }
};
</script>
